// extracted by mini-css-extract-plugin
export var footer = "r_bB";
export var links = "r_bC";
export var privacy = "r_bD";
export var socialIcon = "r_bF";